import DapDSBreadcrumb from './breadcrumb.component'

export * from './breadcrumb.component'
export default DapDSBreadcrumb

DapDSBreadcrumb.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-breadcrumb': DapDSBreadcrumb
  }
}
